export const sendExportRequest = (url, data) => {
  return ajax({ url, method: 'post', data })
}

export default {
  sendExportRequest
}
